(() => {
  const observed = new WeakSet();
  const positions = new Map();
  function keyFor(group) {
    return location.pathname + ':' + (group.closest('[id^="shopify-section-"]')?.id || 'product') + ':' + group.dataset.index;
  }
  function remember(group) {
    if (group.isConnected) positions.set(keyFor(group), group.scrollLeft);
  }
  // Capture before the theme replaces the option controls on a variant change.
  document.addEventListener('click', event => {
    const group = event.target.closest('.zpc-swatch-scroll .product__color-swatches--inner');
    if (group) remember(group);
  }, true);
  function reveal(group) {
    const selected = group.querySelector('.selected[data-button]');
    if (!selected) return;
    const box = group.getBoundingClientRect();
    const item = selected.getBoundingClientRect();
    if (item.left < box.left || item.right > box.right) group.scrollTo({left: Math.max(0, group.scrollLeft + item.left - box.left - 12), behavior: 'instant'});
  }
  function scan() {
    document.querySelectorAll('[data-section-type="product"]').forEach(section => {
      const source = section.querySelector('[data-zpc-size-labels]');
      if (!source) return;
      let labels;
      try { labels = JSON.parse(source.textContent); } catch (_) { return; }
      section.querySelectorAll('.product__color-chips [data-option-value]').forEach(button => {
        const label = labels[button.dataset.optionValue];
        if (!label) return;
        const text = Array.from(button.childNodes).find(node => node.nodeType === Node.TEXT_NODE);
        if (text && text.textContent.trim() !== label) text.textContent = label;
        if (button.getAttribute('aria-label') !== label) button.setAttribute('aria-label', label);
      });
      section.querySelectorAll('select option').forEach(option => {
        const label = labels[option.value];
        if (label && option.textContent !== label) option.textContent = label;
      });
    });
    document.querySelectorAll('.zpc-swatch-scroll .product__color-swatches--inner').forEach(group => {
      if (observed.has(group)) return;
      observed.add(group);
      const key = keyFor(group);
      if (positions.has(key)) group.scrollTo({left: positions.get(key), behavior: 'instant'});
      group.addEventListener('scroll', () => remember(group), {passive:true});
      new MutationObserver(() => { reveal(group); remember(group); }).observe(group, {subtree:true,attributes:true,attributeFilter:['class']});
      reveal(group);
      remember(group);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, {once:true}); else scan();
  document.addEventListener('shopify:section:load', scan);
  // Restore newly rendered controls in the mutation microtask, before paint.
  const observe = () => new MutationObserver(scan).observe(document.body, {childList:true,subtree:true});
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observe, {once:true}); else observe();
  document.addEventListener('click', event => {
    const link = event.target.closest('.zpc-jumps a[href^="#"]');
    if (!link) return;
    const target = document.getElementById(link.getAttribute('href').slice(1));
    if (!target) return;
    event.preventDefault();
    target.scrollIntoView({block:'start',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
  });
})();
